import config from '../config/config';
import { apiConfig } from '../config/apiConfig';
import ApiService from './apiService';

class PropertyService {
    static instance;

    constructor () {
        if (!PropertyService.instance) {
            this.instance = this;
            this.baseUrl = config['backend-url'].endsWith('/') ? config['backend-url'].slice(0, -1) : config['backend-url'];
            this.useToken = true;
            this.dontUseToken = false;
            this.apiService = new ApiService(this.baseUrl);
        }
        return PropertyService.instance;
    }
 
    async fetchPropertiesByRequestId ( requestId ) {
        const response = await this.apiService.post(
            apiConfig.property.getPropertyDetailsByRequestId,
            { requestId },
            this.useToken,
        );
        if (response.ok) {
            return response.data.property_ids || [];
        } else {
            console.error('Failed to fetch properties:', response.data);
            throw new Error(response.data.message || 'Failed to fetch properties');
        }
    }

    async fetchPropertyDetailsByPropertyId ( propertyId ) {
        const response = await this.apiService.post(
            apiConfig.property.getPropertyDetailsByPropertyId,
            { property_id: propertyId },
            this.useToken,
        )

        if (response.ok) {
            return response.data.property_details || null;
        } else {
            console.error('Failed to fetch property details:', response.data);
            throw new Error(response.data.message || 'Failed to fetch property details');
        }
    }


    async fetchQuickPropertyDetailsByPropertyId ( propertyId ) {
        const response = await this.apiService.post(
            apiConfig.property.getPropertyQuickDetailsByPropertyId,
            { property_id: propertyId },
            this.useToken,
        )

        if (response.ok) {
            return response.data.property_details || null;
        } else {
            console.error('Failed to fetch property details:', response.data);
            throw new Error(response.data.message || 'Failed to fetch property details');
        }
    }









    async updateProperty ( requestId, property_id, formData ) {
        const response = await this.apiService.post(
            apiConfig.property.updateProperty,
            { property_id, requestId, ...formData },
            this.useToken
        )

        return response;
    }
};

export const propertyService = new PropertyService();